import React, {useMemo, useEffect, useState, useRef} from "react";
import { CSVLink } from "react-csv";
import * as reportsCrud from "../../_redux/reportsCrud";
import { useReportsUIContext } from "../ReportsUIContext";
import moment from "moment";


export function OrderArticleLotReportToCSV() {

    const [dataCSV, setDataCSV] = useState([]);
    const [loading, setLoading] = useState(false);
    const csvRef = useRef();

    const reportsUIContext = useReportsUIContext();
    const reportsUIProps = useMemo(() => {
      return {
        queryParams: reportsUIContext.actualReportQueryParams,
      };
    }, [reportsUIContext]);

    const getArticles = ()=>{
        const newQueryParams = {...reportsUIProps.queryParams}
        newQueryParams.pageSize = null;
        if(!loading) {
            setLoading(true);
            reportsCrud.getReportByName("order-articles-lot", newQueryParams).then((response) => {

                /* Las columnas y sus nombres son los que espera la importación por Excel
                   del Movimiento interno de stock de RIGA-FARMA, no cambiarlos */
                const datos = response.data.results.map(item => ({
                    articulo:item.article,
                    sku:item.sku,
                    gtin:item.gtin,
                    lote:item.lot_number,
                    cantidad:item.qty,
                }));

                setDataCSV(datos);
                setLoading(false);
                csvRef.current.link.click();
            }).catch(() => {
                setLoading(false);
            });
        }
    }

    return (
        <>

            <button type="button" onClick={getArticles} className="btn btn-light float-right m-2"> <i className="fa fa-file-excel text-primary"></i>
            Exportar CSV
            </button>

            <CSVLink
                data={dataCSV}
                filename={"OrdenesArticulos_" + moment().format("YYYYMMDD") + ".csv"}
                target="_blank"
                ref={csvRef}
            >
            </CSVLink>
        </>


      );
}
